import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { GoogleAnalyticsService } from 'app/common/service/google-analytics.service';

@Component({
  selector: 'clmtlk-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {



  @ViewChild('loginContent') loginContent: ElementRef;
  private modelRef: NgbModalRef;
  private errorInd: boolean;

  constructor(private modalService: NgbModal,
    private router: Router ,
    private clmtlkService: ClmtlkService,
    private route: ActivatedRoute,
    public clmtlkSessionService: ClmtlkSessionService,
    private googleAnalyticsService: GoogleAnalyticsService) {
    // override the route reuse strategy
      //   this.router.routeReuseStrategy.shouldReuseRoute = function(){
      //     return false;
      //  };

      //  this.router.events.subscribe((evt) => {
      //    if (evt instanceof NavigationEnd) {
      //        // trick the Router into believing it's last link wasn't previously loaded
      //        this.router.navigated = false;
      //     }
      //   });
    }

  ngOnInit() {
    if (this.clmtlkSessionService.pinCode && this.clmtlkSessionService.pinCode !== null) {
      this.errorInd = true;
    }
  }

  login(form) {
    this.clmtlkSessionService.pinCode = form.value.pinCode;
    this.router.navigateByUrl('/inbox');
  }


  ngAfterViewInit(): void {
    setTimeout( () => {
        this.openLoginModal(this.loginContent);
     }, 200);
  }

  openLoginModal(loginContent) {
    const modalOptions: any = { backdrop: 'static', keyboard: false };
    this.modelRef = this.modalService.open(this.loginContent, modalOptions);
    this.modelRef.result.then();
  }

  ngOnDestroy(): void {
    this.modelRef.close();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/login/login.component.ts